import { render, staticRenderFns } from "./TopicReading.vue?vue&type=template&id=49f614e0&scoped=true&"
import script from "./TopicReading.vue?vue&type=script&lang=js&"
export * from "./TopicReading.vue?vue&type=script&lang=js&"
import style0 from "./TopicReading.vue?vue&type=style&index=0&id=49f614e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f614e0",
  null
  
)

export default component.exports